import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'store/store';
import { Box, BoxOverflow, Stack } from 'styles';
import { IDocumentStructure } from 'types/Document';
import DocumentRenderer from './DocumentRenderer.component';
import DocumentsList from './DocumentsList.component';

const Documentation = () => {
	const { typology } = useParams();
	const navigate = useNavigate();

	const { documents, expandView } = useSelector(
		(store: RootState) => store.documentation,
	);
	const [selectedDocument, setSelectedDocument] = useState<
		IDocumentStructure | undefined
	>();

	const handleClickSelectDocument = (id: number) => {
		const selectedDoc = documents.find(doc => doc.id === id);
		navigate(`/documentation/${selectedDoc?.attributes.typology}`);
	};

	useEffect(() => {
		if (!documents.length) {
			return;
		}
		if (!typology) {
			setSelectedDocument(documents[0]);
			return;
		}
		const foundDoc = documents.find(doc => doc.attributes.typology === typology);
		setSelectedDocument(foundDoc ?? documents[0]);
	}, [documents, typology]);

	return documents?.length > 0 ? (
		<Stack
			mt={{ sm: '26px', lg: '40px' }}
			minHeight={{
				sm: 'calc(100% - 30px)',
				lg: 'calc(100% - 46px)',
			}}
			direction="row"
			gap={'20px'}
			pb={{ sm: '20px', lg: '40px' }}
		>
			{expandView && (
				<Stack>
					<BoxOverflow
						variant="y"
						sx={{
							cursor: 'pointer',
							width: { sm: '267px', lg: '497px' },
						}}
					>
						<DocumentsList
							documents={documents}
							selectedDocId={selectedDocument?.id}
							onSelectDocument={handleClickSelectDocument}
						/>
					</BoxOverflow>
				</Stack>
			)}
			<Box
				width={{
					sm: expandView ? 'calc(100% - 267px - 20px)' : '100%',
					lg: expandView ? 'calc(100% - 497px - 20px)' : '100%',
				}}
			>
				{selectedDocument && (
					<DocumentRenderer selectedDocument={selectedDocument} />
				)}
			</Box>
		</Stack>
	) : null;
};

export default Documentation;
